"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichRouter = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@apollo/client/react");
const moize_1 = __importDefault(require("moize"));
const react_router_1 = require("react-router");
const request_loader_1 = __importDefault(require("./request-loader"));
const router_constants_1 = require("./router.constants");
const routes_1 = require("./routes");
const apollo_client_1 = require("../apollo-client");
const generic_1 = require("../generic");
const enrich_managers_1 = require("../enrich.managers");
const hooks_1 = require("../hooks");
const localization_1 = require("../localization");
const selectors_1 = require("../store/selectors");
const utils_1 = require("../utils");
const getRoutes = (0, moize_1.default)((sections) => (0, utils_1.extractRoutes)(sections).map((route) => (Object.assign(Object.assign({}, route), { component: enrich_managers_1.Managers[route.name] }))));
const canUserRoleViewRoute = (roles, userRole) => roles.includes(userRole);
const EnrichRouter = () => {
    const enrichPath = (0, hooks_1.useEnrichPath)();
    const role = (0, selectors_1.useUserRoleSelector)();
    const isRoleLoading = (0, selectors_1.useIsUserRoleLoadingSelector)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const routes = getRoutes((0, routes_1.getEnrichRoutes)(featureFlagsService).sections).filter(({ disabled, roles, }) => !(0, utils_1.isRouteDisabled)(disabled) && canUserRoleViewRoute(roles, role));
    const client = (0, apollo_client_1.useGetApolloClient)();
    return (react_1.default.createElement(request_loader_1.default, null, react_1.default.createElement(localization_1.LocalizationProvider, null, react_1.default.createElement(react_2.ApolloProvider, { client: client }, isRoleLoading
        ? react_1.default.createElement(generic_1.SimpleLoading, null)
        : (react_1.default.createElement(react_router_1.Routes, null, routes.length ? (react_1.default.createElement(react_1.default.Fragment, null, routes.map(({ path, name, component: Manager }) => (react_1.default.createElement(react_router_1.Route, { path: path, element: Manager ? react_1.default.createElement(Manager, null) : react_1.default.createElement(react_1.default.Fragment, null), key: name }))), react_1.default.createElement(react_router_1.Route, { path: "*", element: react_1.default.createElement(react_router_1.Navigate, { to: `${enrichPath}/${router_constants_1.EnrichSection.ProductEditor}/viewer` }) }))) : (react_1.default.createElement(react_router_1.Route, { path: "*", element: react_1.default.createElement(react_router_1.Navigate, { to: "/" }) }))))))));
};
exports.EnrichRouter = EnrichRouter;
exports.default = exports.EnrichRouter;
